export default Object.freeze({
  RootObject: 'ROOT_OBJECT',
  ViewerObject: 'VIEWER_OBJECT',
  Wrapper: 'WRAPPER',
  Entity: 'ENTITY',
  EntitySet: 'ENTITY_SET',
  Union: 'UNION',
  Interface: 'INTERFACE',
  UnionSet: 'UNION_SET',
  InterfaceSet: 'INTERFACE_SET',
  InlineFragmentEntity: 'INLINE_FRAGMENT_ENTITY',
  InlineFragmentTypedObject: 'INLINE_FRAGMENT_TYPED_OBJECT',
  Embed: 'EMBED',
  EmbedList: 'EMBED_LIST'
});
